<template>
    <div class="checkSfz">
      <div class='container'>
        <div class='row text-center'>
          <div class='col-md-12'>
            <textarea class="form-control" rows="10" placeholder="请输入身份证号码,多个身份证号码用逗号分隔" v-model="sfzStr"></textarea>
            <br>
            <div class="btn btn-primary" @click="DoClick" style="margin-bottom:40px">检查身份证合法</div>
            <br>
          </div>
          <div class='col-md-6'>
            <p v-html="succMsg"></p>
          </div>
          <div class='col-md-6'>
            <p v-html="failMsg"></p>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'CheckSFZ',
    data() {
      return {
        sfzStr:"",
        succMsg:"",
        failMsg:"",
      }
    },
    methods:{
        DoClick(){
          this.succMsg ="";
          this.failMsg ="";
          var sfzArr = this.sfzStr.split(',');
          for(var i=0;i<sfzArr.length;i++)
          {
            var sfz = sfzArr[i];
            if(this.isCardNo(sfz)){
              this.succMsg += "<span style='color:green'>"+sfz+":身份证合法"+"</span><br>";
            }
            else{
              this.failMsg += "<span style='color:red'>"+sfz+":身份证不合法"+"</span><br>";
            }
          }
        },
        isCardNo(num) {
        num = num.toUpperCase();
        //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。   
        if (!(/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(num))) {
            return false;
        }
        //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。 
        //下面分别分析出生日期和校验位 
        var len, re;
        len = num.length;
        if (len == 15) {
            re = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/);
            var arrSplit = num.match(re);

            //检查生日日期是否正确 
            var dtmBirth = new Date('19' + arrSplit[2] + '/' + arrSplit[3] + '/' + arrSplit[4]);
            var bCorrectDay;
            bCorrectDay = (dtmBirth.getYear() == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) &&
                (
                    dtmBirth.getDate() == Number(arrSplit[4]));
            if (!bCorrectDay) {
                return false;
            } else {
                //将15位身份证转成18位 
                //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。 
                var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
                var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
                var nTemp = 0,
                    i;
                num = num.substr(0, 6) + '19' + num.substr(6, num.length - 6);
                for (i = 0; i < 17; i++) {
                    nTemp += num.substr(i, 1) * arrInt[i];
                }
                num += arrCh[nTemp % 11];
                return true;
            }
        }
        if (len == 18) {
            re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
            var arrSplit = num.match(re);

            //检查生日日期是否正确 
            var dtmBirth = new Date(arrSplit[2] + "/" + arrSplit[3] + "/" + arrSplit[4]);
            var bCorrectDay;
            bCorrectDay = (dtmBirth.getFullYear() == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) &&
                (dtmBirth.getDate() == Number(arrSplit[4]));
            if (!bCorrectDay) {
                return false;
            } else {
                //检验18位身份证的校验码是否正确。 
                //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。 
                var valnum;
                var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
                var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
                var nTemp = 0,
                    i;
                for (i = 0; i < 17; i++) {
                    nTemp += num.substr(i, 1) * arrInt[i];
                }
                valnum = arrCh[nTemp % 11];
                if (valnum != num.substr(17, 1)) {
                    return false;
                }
                return true;
            }
        }
        return false;
      }
        
    },
    computed:{
      
    },
    mounted()
    {
        
    }
  }
  </script>